import { EditType, EditableCellProps } from "@components/EditableCell"
import { CellOption } from "@features/graph/details/components/TableNodeDetails/NodeTable"
import { BaseGraphTableNode } from "@store/services/converter/types"

export const getTableRows = (
  table: BaseGraphTableNode,
  { editable, onBlur }: CellOption,
): EditableCellProps[][] => {
  const rows: EditableCellProps[][] = []

  for (let rowIndex = 0; rowIndex < table.index.length; rowIndex++) {
    rows[rowIndex] = [
      {
        // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
        value: table.index[rowIndex],
        editable,
        type: EditType.Number,
        onBlur: (newValue) => onBlur("index", rowIndex, 0, newValue),
      },
    ]

    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    table.data[rowIndex].forEach((value, cellIndex) => {
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      rows[rowIndex].push({
        value: value.toString(),
        editable,
        type: EditType.Number,
        onBlur: (newValue) => onBlur("data", rowIndex, cellIndex, newValue),
      })
    })
  }

  return rows
}
